export default __webpack_public_path__ + "static/media/spark_76.978b7b58.png";